<template>
  <div :class="$style.toolbar">
    <div :class="$style.fileInfo">
      <SCAIconButton
        v-if="onClose"
        :class="$style.mobileCloseButton"
        appearance="inverted"
        type="ghost"
        size="xsmall"
        icon="phosphor/x"
        @click="onClose()"
      />
      <span :class="$style.fileName">{{ fileName || "Untitled" }}</span>
    </div>
    <div :class="$style.toolbarButtons">
      <SCAIconButton
        size="small"
        appearance="secondary"
        icon="phosphor/magnifying-glass-plus"
        @click="$emit('zoom-in')"
      />
      <SCAIconButton
        size="small"
        appearance="secondary"
        icon="phosphor/magnifying-glass-minus"
        @click="$emit('zoom-out')"
      />
      <SCAIconButton
        size="small"
        appearance="secondary"
        icon="phosphor/arrow-counter-clockwise"
        @click="$emit('rotate-left')"
      />
      <SCAIconButton
        :class="$style.flipHorizontal"
        size="small"
        appearance="secondary"
        icon="phosphor/arrow-counter-clockwise"
        @click="$emit('rotate-right')"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { SCAIconButton } from "@scayla/components";

withDefaults(
  defineProps<{
    scale: number;
    fileName: string;
    onClose?: () => void;
  }>(),
  { onClose: undefined },
);

defineEmits(["zoom-in", "zoom-out", "rotate-left", "rotate-right"]);
</script>

<style lang="scss" module>
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-component-gap-small);
  padding: 0 var(--space-component-padding-medium);
  background: var(--color-background-inverted);
  color: var(--color-whiteA-0);
  backdrop-filter: blur(8px);
  width: 100%;
  height: var(--dimension-550);
  overflow: hidden;
  @include Globals.typo-header-small;
}

.toolbarButtons {
  display: flex;
  align-items: center;
  gap: var(--space-component-gap-small);
  flex-shrink: 0;
}

.fileInfo {
  display: flex;
  align-items: center;
  gap: var(--space-component-gap-small);
  flex: 1 1 auto;
  min-width: 0;
}

.fileName {
  color: var(--color-content-primary-inverted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1 auto;
}

.flipHorizontal {
  transform: scaleX(-1);
}

.mobileCloseButton {
  display: none;

  width: var(--dimension-300) !important;
  height: var(--dimension-300) !important;

  @media (max-width: 478px) {
    display: inline-flex;
  }
}
</style>
